import { render } from "./ProductBasicInfo.vue?vue&type=template&id=18bc4a6a"
import script from "./ProductBasicInfo.vue?vue&type=script&lang=js"
export * from "./ProductBasicInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__